import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GradButton, Field, fmtMoney } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { bugun } from "@/components/ortak/Liste";
import api, { errMsg } from "@/lib/api";

export const useSecenekler = () => {
  const [s, setS] = useState({ tipler: [], cariler: [], projeler: [] });
  useEffect(() => {
    Promise.all([api.get("/gider-tipleri"), api.get("/cariler").catch(() => ({ data: [] })), api.get("/projeler").catch(() => ({ data: [] }))]).then(([t, c, p]) => setS({
      tipler: t.data.map((x) => ({ value: x.id, label: x.ad })),
      cariler: [{ value: "", label: "Genel Gider (cari yok)" }, ...(c.data.items || c.data).map((x) => ({ value: x.id, label: x.unvan }))],
      projeler: [{ value: "", label: "Proje yok" }, ...p.data.map((x) => ({ value: x.id, label: x.ad }))],
    }));
  }, []);
  return s;
};

const KDV = [0, 1, 10, 20].map((n) => ({ value: String(n), label: `%${n}` }));
const Inp = ({ id, l, v, set, type = "text" }) => <Field label={l}><Input data-testid={id} type={type} value={v ?? ""} onChange={(e) => set(e.target.value)} className="bg-white/5" /></Field>;

export const GiderForm = ({ kayit, ilk, onClose, onDone }) => {
  const s = useSecenekler();
  const [f, setF] = useState(() => ({ tip_id: "", cari_id: "", proje_id: "", seri_no: "", tarih: bugun(), vade_tarihi: "", tutar: "", kdv_orani: "20", etiketler: "", aciklama: "", ...(ilk || {}), ...(kayit || {}), ...(kayit ? { kdv_orani: String(kayit.kdv_orani) } : {}) }));
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  const toplam = (+f.tutar || 0) * (1 + (+f.kdv_orani || 0) / 100);
  const kaydet = async () => {
    if (!f.tip_id || !(+f.tutar > 0)) { toast.error("Gider tipi ve tutar zorunlu"); return; }
    setBusy(true);
    const body = { tip_id: f.tip_id, cari_id: f.cari_id, proje_id: f.proje_id, seri_no: f.seri_no, tarih: f.tarih, vade_tarihi: f.vade_tarihi, tutar: +f.tutar, kdv_orani: +f.kdv_orani, etiketler: f.etiketler, aciklama: f.aciklama };
    try { const r = kayit ? await api.put(`/giderler/${kayit.id}`, body) : await api.post("/giderler", body); toast.success(kayit ? "Gider güncellendi" : "Gider eklendi"); onDone(r.data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}><DialogContent className="glass max-w-3xl max-h-[92vh] overflow-y-auto" data-testid="gider-form">
      <DialogHeader><DialogTitle>{kayit ? "Genel Gideri Düzenle" : "Yeni Genel Gider"}</DialogTitle></DialogHeader>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Gider tipi *"><SelectBox testid="gider-tip" value={f.tip_id} onChange={set("tip_id")} options={s.tipler} /></Field>
        <Field label="Cari (tedarikçi)"><SelectBox testid="gider-cari" value={f.cari_id} onChange={set("cari_id")} options={s.cariler} /></Field>
        <Inp id="gider-seri" l="Seri numarası" v={f.seri_no} set={set("seri_no")} />
        <Field label="Proje"><SelectBox testid="gider-proje" value={f.proje_id} onChange={set("proje_id")} options={s.projeler} /></Field>
        <Inp id="gider-tarih" l="Düzenleme tarihi *" type="date" v={f.tarih} set={set("tarih")} />
        <Inp id="gider-vade" l="Vade tarihi" type="date" v={f.vade_tarihi} set={set("vade_tarihi")} />
        <Inp id="gider-tutar" l="Tutar (KDV hariç) * TRY" type="number" v={f.tutar} set={set("tutar")} />
        <Field label="KDV"><SelectBox testid="gider-kdv" value={f.kdv_orani} onChange={set("kdv_orani")} options={KDV} /></Field>
        <Inp id="gider-etiket" l="Etiketler" v={f.etiketler} set={set("etiketler")} />
        <Inp id="gider-aciklama" l="Açıklama" v={f.aciklama} set={set("aciklama")} />
      </div>
      <div className="flex items-center gap-2"><span className="text-sm text-muted-foreground">Genel Toplam: <b className="font-mono text-foreground" data-testid="gider-genel-toplam">{fmtMoney(toplam)}</b></span>
        <div className="ml-auto flex gap-2"><button onClick={onClose} className="px-4 h-10 rounded-full text-sm bg-white/5">İptal</button><GradButton data-testid="gider-kaydet" onClick={kaydet} disabled={busy}>Kaydet</GradButton></div></div>
    </DialogContent></Dialog>
  );
};

export const OdeDialog = ({ gider, onClose, onDone }) => {
  const [hesaplar, setHesaplar] = useState([]);
  const [h, setH] = useState("");
  const [tarih, setTarih] = useState(bugun());
  useEffect(() => { api.get("/hesaplar/secenekler").then((r) => setHesaplar(r.data.filter((x) => x.para_birimi === "TRY").map((x) => ({ value: x.id, label: `${x.ad} (${x.tip === "kasa" ? "Kasa" : x.tip === "kredi_karti" ? "Kredi Kartı" : "Banka"})` })))); }, []);
  const ode = async () => { try { await api.post(`/giderler/${gider.id}/ode`, { hesap_id: h, tarih }); toast.success("Ödeme kaydedildi"); onDone(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}><DialogContent className="glass max-w-md" data-testid="gider-ode">
      <DialogHeader><DialogTitle>Ödeme Yap · {fmtMoney(gider.genel_toplam)}</DialogTitle></DialogHeader>
      <Field label="Ödenen hesap (banka / kasa / kart) *"><SelectBox testid="gider-ode-hesap" value={h} onChange={setH} options={hesaplar} /></Field>
      <Inp id="gider-ode-tarih" l="Ödeme tarihi" type="date" v={tarih} set={setTarih} />
      <div className="flex justify-end gap-2"><button onClick={onClose} className="px-4 h-10 rounded-full text-sm bg-white/5">İptal</button><GradButton data-testid="gider-ode-kaydet" disabled={!h} onClick={ode}>Ödemeyi Kaydet</GradButton></div>
    </DialogContent></Dialog>
  );
};
